<template>
  <div class="back-btn" @click="goBack">
    <icon :name="icon"/>
  </div>
</template>

<script>
  import {Icon} from "vant"

  export default {
    name: "Goback",
    components: {
      Icon
    },
    props: {
      path: {
        type: String,
        value: "",
      },
      iconName: {
        type: String,
        value: "",
      }
    },
    data() {
      return {
        icon: "arrow-left",
      }
    },
    mounted() {
      if (this.iconName) {
        this.icon = this.iconName
      }
    },
    methods: {
      goBack() {
        if (this.path) {
          this.$router.push(this.path)
        } else {
          this.$router.go(-1)
        }
      },
    }
  }
</script>

<style scoped>
  .back-btn {
    position: fixed;
    z-index: 9999;
    top: 10px;
    left: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.17);
  }
</style>
